module.exports = __webpack_public_path__ + "static/media/office-map.0e37773a.png";